import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/about/AboutPageView.tsx");
